import { render } from "./PayrollSetupManagement.vue?vue&type=template&id=0c5a3bec&scoped=true"
import script from "./PayrollSetupManagement.vue?vue&type=script&lang=js"
export * from "./PayrollSetupManagement.vue?vue&type=script&lang=js"

import "./PayrollSetupManagement.vue?vue&type=style&index=0&id=0c5a3bec&scoped=true&lang=css"
import "./PayrollSetupManagement.vue?vue&type=style&index=1&id=0c5a3bec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5a3bec"]])

export default __exports__